module.exports = __webpack_public_path__ + "static/media/consulting.e8da4d64.png";